import { currentUserSliceActions } from "./currentUserSlice"
import { mainApi } from "../../../common/api/endpoints/mainApi"
import { handleResponseError } from "../../../common/api/middleware"
import { showErrorNotification } from "../../../common/utils/ui"
import { TAppDispatch } from "../../store"
import { appActions } from "../app/actions"

export const currentUserActions = {
    ...currentUserSliceActions,

    currentUserGetData: (onFinish: () => void, onError: () => void) => async (dispatch: TAppDispatch) => {
        // dispatch(appActions.setAppLoading(true))

        mainApi.getUserInfo()
            .then((response) => {
                if (response.status === 200) {
                    const data = response.data

                    dispatch(currentUserActions.currentUserSetData({
                        id: data.id,
                        name: data.name,
                        username: data.username,
                        group: data.group_id,
                        role: data.role_id
                    }))

                    onFinish()
                }
            })
            .catch((err) => {
                handleResponseError(dispatch, err)
                onError()
            })
    },

    currentUserSendCallStatus: (id: number, status: number, note: string, onFinish: () => void, onError: () => void, operator_id?: number) => async () => {
        mainApi.sendCallStatus(id, status, note, operator_id)
            .then((response) => {
                if (response.status === 200) {
                    onFinish()
                }
            })
            .catch(() => {
                onError()
            })
    },

    currentUserGetStatus: (onFinish?: () => void, onError?: () => void) => async (dispatch: TAppDispatch) => {
        mainApi.getUserStatus()
            .then((response) => {
                if (response.status === 200) {
                    dispatch(currentUserActions.currentUserSetCall(response.data.queue))
                    
                    // Парсим subscription_info из JSON строки
                    let subscription = null
                    if (response.data.connection?.subscription_info) {
                        try {
                            subscription = JSON.parse(response.data.connection.subscription_info)
                        } catch (e) {
                            console.error("Failed to parse subscription_info:", e)
                        }
                    }
                    
                    // Парсим autocall_sources из JSON строки (если это строка)
                    let autocall_sources: number[] = []
                    if (response.data.connection?.autocall_sources) {
                        const sources = response.data.connection.autocall_sources
                        if (typeof sources === "string") {
                            try {
                                autocall_sources = JSON.parse(sources)
                            } catch (e) {
                                console.error("Failed to parse autocall_sources:", e)
                            }
                        } else if (Array.isArray(sources)) {
                            autocall_sources = sources
                        }
                    }
                    
                    dispatch(currentUserActions.currentUserSetConnectionStatus({
                        ...response.data.connection,
                        subscription,
                        autocall_sources
                    }))
                }
                onFinish && onFinish()
            })
            .catch((err) => {
                handleResponseError(dispatch, err)
                onError && onError()
            })
    },

    currentUserGetLocations: (onFinish?: () => void) => async (dispatch: TAppDispatch) => {
        dispatch(currentUserActions.currentUserSetLocationsLoading(true))

        mainApi.getUserLocations()
            .then((response) => {
                if (response.status === 200) {
                    dispatch(currentUserActions.currentUserSetLocationList(response.data))
                    onFinish && onFinish()
                }
            })
            .catch(() => {
                showErrorNotification("Ошибка при загрузке локаций. Перезагрузите страницу.")
            })
            .finally(() => {
                dispatch(currentUserActions.currentUserSetLocationsLoading(false))
                dispatch(appActions.setAppLoading(false))
            })
    },

    currentUserUpdatePhoneStatus: (status: 2 | 4) => async (dispatch: TAppDispatch) => {
        dispatch(currentUserActions.currentUserSetPhoneStatus(status))

        mainApi.updateUserStatus(status)
            .catch(() => {
                showErrorNotification("Ошибка при обновлении статуса. Повторите попытку позже.")
                dispatch(currentUserActions.currentUserSetPhoneStatus(4))
            })
    },

    currentUserUpdateLocations: (newLocations: { id: number, name: string, status: boolean }[], onFinish: () => void, onError: () => void) => async () => {
        mainApi.updateUserLocations(newLocations)
            .then((response) => {
                if (response.status === 200) {
                    onFinish()
                }
            })
            .catch(() => {
                showErrorNotification("Ошибка при обновлении локаций. Повторите попытку позже.")
                onError()
            })
    },
}
